import { observable } from "mobx";
import { Type } from "class-transformer";
import DistributorRefundChargeResponse from "./distributorRefundChargeResponse";
import RefundApprovalResponse from "./refundApprovalResponse";
import Approvable from "./approvable";
import DistributorPaymentRequestResponse from "./distributorPaymentRequestResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorRefundDetailResponse extends Approvable {
  id!: string;

  @observable
  refundReason!: string;

  @observable
  refundAmount!: number;

  @observable
  distributorName!: string;

  @observable
  @Type(() => DistributorPaymentRequestResponse)
  distributorPaymentRequest!: DistributorPaymentRequestResponse;

  @observable
  variableSymbol!: number;

  @observable
  @Type(() => DistributorRefundChargeResponse)
  charges!: DistributorRefundChargeResponse[];

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];
}
